import { EOrderAsLastTimeState, IOrderState } from '@model';

export interface IPaypalComponent {
  clientId: string;
  setPageState: (state: EOrderAsLastTimeState) => void;
  setComponentState: (state: EPaypalComponentState) => void;
  onSuccess: () => void;
  checkoutInitOrder: () => Promise<IOrderState | null>;
}

export enum EPaypalComponentState {
  PAYMENT,
  SUCCESS,
  ERROR,
}
